export default __webpack_public_path__ + "static/1025-3073c5728a819bddca81aaae6a7cf06b.gif";